/**
 * Redirect targets that are themselves an onboarding flow. Applicants on
 * /become-creator have no plan and often no completed profile, so the
 * /choose-plan or /account/complete detour would strand them away from the
 * application they signed in to finish.
 */
const ONBOARDING_EXEMPT_REDIRECTS: ReadonlySet<string> = new Set(['/become-creator']);

export function resolvePostLoginPath(
  onboardingPath: string | null,
  redirectTo: string | null
): string {
  if (redirectTo && ONBOARDING_EXEMPT_REDIRECTS.has(redirectTo)) return redirectTo;
  return onboardingPath || redirectTo || '/';
}
